import type { ApolloCache } from "@apollo/client/cache";

// Ob die Person sich auf eine Ausschreibung bewerben kann, rechnet genesis (`Listing.actions.canApply`).
// Nach einer Bewerbung oder einem Rückzug ist der Wert im Cache veraltet; Apollo fragt ihn danach neu,
// eine gerade angezeigte Seite sofort.
export function forgetCanApply(cache: ApolloCache, listingId: string) {
  cache.evict({ id: cache.identify({ __typename: "Listing", id: listingId }), fieldName: "actions" });
  cache.gc();
}

// Nach einer Bewerbung, auch einer abgelehnten, kommt dazu die Liste der eigenen Bewerbungen: eine
// neue Bewerbung kennt sie noch nicht, und "bereits beworben" soll die Seite dahinter zeigen. Ein
// Rückzug braucht das nicht, seine Antwort setzt die Bewerbung im normalisierten Cache selbst neu.
export function forgetApplicationState(cache: ApolloCache, listingId: string) {
  cache.evict({ fieldName: "myListingApplications" });
  forgetCanApply(cache, listingId);
}

// Eine nach der Anmeldung fortgesetzte öffentliche Bewerbung nennt ihre Ausschreibung nicht: vergessen werden die eigene
// Liste und die offenen Ausschreibungen, damit "bereits beworben" beim nächsten Besuch stimmt.
export function forgetClaimedApplication(cache: ApolloCache) {
  cache.evict({ fieldName: "myListingApplications" });
  cache.evict({ fieldName: "openListings" });
  cache.evict({ fieldName: "openListing" });
  cache.gc();
}
